import type { Nullable } from '@ats/interfaces';
import useElementAspectRatio from '@hooks/ref/useElementAspectRatio';
import type { FC, HTMLAttributes, PropsWithChildren } from 'react';
import React, { createContext, createRef, useContext } from 'react';
import { Container } from './style';

export interface VideoGridProps extends HTMLAttributes<HTMLDivElement> {
  /** The number of tiles to lay out. */
  size?: number;
}

interface GridContext {
  usingGrid: boolean;
}

const gridData = { usingGrid: true };
const GridContext = createContext<Nullable<GridContext>>(null);

export const CandidateVideoGrid: FC<PropsWithChildren<VideoGridProps>> = ({
  size,
  children,
  ...rest
}) => {
  const gridEl = createRef<HTMLDivElement>();
  const ratio = useElementAspectRatio(gridEl);
  const gridSize =
    typeof size === 'number' ? size : React.Children.count(children);

  return (
    <GridContext.Provider value={gridData}>
      <Container
        ref={gridEl}
        {...rest}
        size={gridSize}
        ratio={ratio}
        featured={false}
        data-testid='video-grid'
      >
        {children}
      </Container>
    </GridContext.Provider>
  );
};

export const useGridData = () => {
  const gridData = useContext(GridContext);

  return gridData;
};

export default CandidateVideoGrid;
